// extracted by mini-css-extract-plugin
export default {"container":"container__qKQzI","content":"content__UooAg","image":"image__c5GB2"};